import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getDefaultFetchOptions } from './utils';
import type { CurrentUser } from '@shared/types/user';

const fetchCurrentUser = async (): Promise<CurrentUser | null> => {
  try {
    const res = await fetch('/api/me', {
      ...getDefaultFetchOptions(),
    });

    if (!res.ok) {
      return null;
    }

    const data = await res.json();
    return data.user || null;
  } catch {
    return null;
  }
};

export const useCurrentUser = () => {
  return useQuery<CurrentUser | null>({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export const useInvalidateCurrentUser = () => {
  const queryClient = useQueryClient();

  return () => {
    return queryClient.invalidateQueries({ queryKey: ['currentUser'] });
  };
};
